import SmartNavigator from '../generic/SmartNavigator'
import GenericKPIs from '../dashboard/GenericKPIs'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import useSmartTranslation from '../generic/hooks/useSmartTranslation/useSmartTranslation'

const MainDashboardOEE = () => {
  const [config] = useFrontEndConfig()

  const { t_ } = useSmartTranslation()

  if (config === null) return null

  const componentsInfo = [
    {
      title: t_('OEE'),
      component: <GenericKPIs dashboardsUrl='/dashboards/d/demnurgwc4l4wf' />,
      permissionCode: 'DASHBOARD_OEE'
    }
  ]

  return (
    <SmartNavigator componentsInfo={componentsInfo} />
  )
}

export default MainDashboardOEE
